/**
 * 文の台帳（training）。まとめは ../ui-texts.ts。
 * 管理UIへ写すので、../ui-texts.ts の型の他は何も import しない
 */
import type { UiTextDef } from "../ui-texts";

export const TRAINING_TEXTS = {
  // 精霊を選んでいないとき
  "training.empty.message": { text: "獲得精霊タブから精霊を選んでください", label: "精霊を選んでいないときの文" },
  "training.empty.goInventory": { text: "獲得精霊タブへ", label: "精霊を選んでいないときのボタン" },
  "training.release.done": { text: "{名前} を手放しました", label: "手放した後の知らせ", note: "手放した直後、精霊を選んでいない画面に出る（紺の札の見出し）", vars: "{名前}" },
  "training.release.magic": { text: "魔力 +{魔力}", label: "手放した後の知らせ（もらった魔力）", note: "魔力をもらえたときだけ", vars: "{魔力}" },

  // 戻るボタン
  "training.back.party": { text: "← 手持ちに戻る", label: "手持ちに戻るボタン", note: "手持ち精霊の画面から開いたときだけ" },
  "training.back.inventory": { text: "← 精霊一覧に戻る", label: "精霊一覧に戻るボタン" },

  // 精霊のカード
  "training.card.inHand": { text: "手持ち", label: "額の左上の手持ちの判", note: "手持ちに登録している精霊だけ。大きいカードと小さいカードの両方" },
  "training.card.level": { text: "Lv.{レベル}", label: "カードのレベル", note: "大きいカード・小さいカード・入れ替える精霊の一覧", vars: "{レベル}" },
  "training.card.exp": { text: "経験", label: "大きいカードの経験値の名前" },
  "training.card.zoom": { text: "拡大", label: "大きいカードの額の右下の拡大ボタンの下の字" },
  "training.card.record": { text: "精霊の記録", label: "精霊の説明の札の見出し" },
  "training.card.recordMore": { text: "続きを読む ▾", label: "精霊の説明の札（2行でたたんでいるとき）" },
  "training.card.recordLess": { text: "たたむ ▴", label: "精霊の説明の札（全部出しているとき）" },
  "training.card.noRecord": { text: "説明文はまだ登録されていません", label: "精霊の説明の札（説明が無いとき）" },
  "training.card.evolution": { text: "進化 {段階}/{最大}", label: "大きいカードの進化の段階", vars: "{段階}・{最大}" },
  "training.card.crossEvolve": { text: " (転進化可)", label: "大きいカードの進化の段階の後ろ（転進化できるとき）", note: "転進化できる精霊だけ。前の空白も文のうち" },
  "training.card.compactStatus": { text: "{経験値} / {次まで} EXP 　進化 {段階}/{最大}", label: "小さいカードの経験値と進化の段階", note: "育成・進化などの欄を開いているとき", vars: "{経験値}・{次まで}・{段階}・{最大}" },

  // スキル
  "training.skill.heading": { text: "スキル", label: "スキルの見出し" },
  "training.skill.locked": { text: "条件を満たすと解放", label: "スキルの説明（まだ解放していないとき）" },
  "training.skill.expBoost": { text: "EXPブースト ×{倍率}", label: "スキルの名前（EXPブースト）", vars: "{倍率}" },
  "training.skill.expBoostDetail": { text: "読了時、手持ち精霊のEXPを増加", label: "スキルの説明（EXPブースト）" },
  "training.skill.readBonus": { text: "読了ボーナス", label: "スキルの名前（読了ボーナス）", note: "説明には素材の名前と数が出る" },
  "training.skill.gachaUnlock": { text: "ガチャ解放率UP", label: "スキルの名前（ガチャ解放率UP）" },
  "training.skill.gachaUnlockDetail": { text: "{属性}（{確率}%）", label: "スキルの説明（ガチャ解放率UP）", vars: "{属性}・{確率}" },

  // 手持ちの登録
  "training.hand.processing": { text: "処理中...", label: "手持ちの登録・解除のボタン（処理中）" },
  "training.hand.unset": { text: "手持ちを解除する", label: "手持ちを解除するボタン", note: "手持ちに登録している精霊だけ" },
  "training.hand.replaceQuestion": { text: "どの精霊と入れ替えますか？", label: "入れ替える精霊を選ぶ欄の問い", note: "手持ちがいっぱいで、入れ替えを押したとき" },
  "training.hand.replaceCancel": { text: "キャンセル", label: "入れ替える精霊を選ぶ欄のキャンセル" },
  "training.hand.setReplace": { text: "手持ちに登録する（入れ替え）", label: "手持ちに登録するボタン（手持ちがいっぱいのとき）" },
  "training.hand.set": { text: "手持ちに登録する（{今}/{上限}）", label: "手持ちに登録するボタン", vars: "{今}・{上限}" },

  // 4つのボタン
  "training.actions.evolve": { text: "進化", label: "4つのボタン（進化）" },
  "training.actions.evolveNone": { text: "進化不可", label: "4つのボタン（進化しない精霊）" },
  "training.actions.evolveMax": { text: "最大進化済", label: "4つのボタン（進化しきった精霊）" },
  "training.actions.train": { text: "育成", label: "4つのボタン（育成）" },
  "training.actions.journey": { text: "旅", label: "4つのボタン（旅）" },
  "training.actions.release": { text: "手放す", label: "4つのボタン（手放す）" },
  "training.actions.onJourney": { text: "旅の途中", label: "旅のボタンの下の小さな文（旅の途中）" },
  "training.actions.inHand": { text: "手持ち登録中", label: "旅のボタンの下の小さな文（手持ちに登録しているとき）", note: "手持ちの精霊は旅に出せない" },

  // 育成の欄
  "training.train.title": { text: "素材を使って育成", label: "育成の欄の見出し" },
  "training.train.empty": { text: "素材がありません。小説を読了すると素材がドロップします。", label: "育成の欄（素材がないとき）" },
  "training.train.owned": { text: "所持: {個数}", label: "育成の欄の素材の持っている数", vars: "{個数}" },
  "training.train.max": { text: "全部", label: "育成の欄の素材を全部使うボタン" },
  "training.train.expLabel": { text: "獲得経験値", label: "育成の欄のもらえる経験値の名前" },
  "training.train.expGain": { text: "+{経験値} EXP", label: "育成の欄のもらえる経験値", vars: "{経験値}" },
  "training.train.buff": { text: "今日の読み方で経験値×{倍率}", label: "育成の欄の今日の読み方のバフ", note: "経験値が増える読み方を選んだ日だけ", vars: "{倍率}" },
  "training.train.preview": { text: "Lv.{レベル} / {経験値} + {獲得} → {合計} EXP", label: "育成の欄の育てた後の見込み", note: "素材を1つ以上選んだとき", vars: "{レベル}・{経験値}・{獲得}・{合計}" },
  "training.train.levelUp": { text: "Lv.{レベル} に上がる", label: "育成の欄の育てた後の見込み（レベルが上がるとき）", note: "見込みの右に出る。{レベル}は育てた後のレベル", vars: "{レベル}" },
  "training.train.feeding": { text: "育成中...", label: "育成するボタン（育成中）" },
  "training.train.submit": { text: "育成する", label: "育成するボタン" },

  // 進化の欄
  "training.evolve.title": { text: "進化 ({段階}/{最大})", label: "進化の欄の見出し", vars: "{段階}・{最大}" },
  "training.evolve.loading": { text: "進化情報を読み込み中...", label: "進化の欄（読み込み中）" },
  "training.evolve.next": { text: "進化先", label: "進化の欄の進化先の名前（今は使っていない）", note: "10/21 から進化先は段階の星座で見せるので、この文は出ない" },
  "training.evolve.stageStart": { text: "はじまりの姿", label: "進化の欄の段階の星座（進化する前の姿）", note: "星座の左端の星の下" },
  "training.evolve.stageN": { text: "進化{段階}段階目", label: "進化の欄の段階の星座（進化した姿）", note: "星座の2つ目から右の星の下", vars: "{段階}" },
  "training.evolve.stagePast": { text: "済み", label: "進化の欄の段階の星座の小さな札（もう通った姿）" },
  "training.evolve.stageNow": { text: "いま", label: "進化の欄の段階の星座の小さな札（いまの姿）" },
  "training.evolve.stageNext": { text: "次", label: "進化の欄の段階の星座の小さな札（次の姿）" },
  "training.evolve.stageLater": { text: "その先", label: "進化の欄の段階の星座の小さな札（次より先の姿）" },
  "training.evolve.genreMaterial": { text: "{属性} 属性素材", label: "進化の欄の要る素材の名前", vars: "{属性}" },
  "training.evolve.materialCount": { text: "{所持} / {必要}個", label: "進化の欄の要る素材の数", vars: "{所持}・{必要}" },
  "training.evolve.materialQuantity": { text: "{個数}個", label: "進化の欄の持っている素材ごとの数", vars: "{個数}" },
  "training.evolve.noMaterial": { text: "{属性} 属性の素材を所持していません", label: "進化の欄（その属性の素材がないとき）", vars: "{属性}" },
  "training.evolve.minLevel": { text: "最低レベル", label: "進化の欄の要るレベルの名前", note: "レベルの条件がある進化だけ" },
  "training.evolve.levelCount": { text: "Lv.{今} / Lv.{必要}以上", label: "進化の欄の要るレベル", vars: "{今}・{必要}" },
  "training.evolve.met": { text: "足りています", label: "進化の欄の条件（満たしたとき）", note: "数の下の小さな文" },
  "training.evolve.short": { text: "あと {数}", label: "進化の欄の条件（足りないとき）", note: "数の下の小さな文。素材は個数、レベルはレベルの差", vars: "{数}" },
  "training.evolve.evolving": { text: "進化中...", label: "進化するボタン（進化中）" },
  "training.evolve.submit": { text: "進化する", label: "進化するボタン" },
  "training.evolve.needLevel": { text: "Lv.{必要}以上が必要です", label: "進化するボタン（レベルが足りないとき）", vars: "{必要}" },
  "training.evolve.needMaterial": { text: "素材が足りません", label: "進化するボタン（素材が足りないとき）" },
  "training.evolve.cannot": { text: "この精霊はこれ以上進化できません", label: "進化の欄（これ以上進化できないとき）" },

  // 旅の欄（帰ってきたとき）
  "training.journey.returned": { text: "帰還しました！", label: "旅の欄の見出し（帰ってきたとき）" },
  "training.journey.affinityApplied": { text: "属性一致ボーナス適用", label: "旅の欄（帰ってきたとき・属性が一致したとき）", note: "前に ✦ の印" },
  "training.journey.magicGained": { text: "魔力 +{魔力}", label: "旅の欄（帰ってきたとき）の持ち帰った魔力", note: "魔力を持ち帰ったときだけ", vars: "{魔力}" },
  "training.journey.droppedTitle": { text: "入手素材", label: "旅の欄の持ち帰った素材の見出し" },
  "training.journey.droppedNone": { text: "素材なし", label: "旅の欄（持ち帰った素材がないとき）" },
  "training.journey.novelFound": { text: "作品を持ち帰りました！", label: "旅の欄（作品を持ち帰ったとき）の見出し", note: "前に ✦ の印。下に作品の題" },
  "training.journey.novelWhere": { text: "未読作品から閲覧できます", label: "旅の欄（作品を持ち帰ったとき）の説明" },
  "training.journey.close": { text: "閉じる", label: "旅の欄（帰ってきたとき）の閉じるボタン" },

  // 旅の欄（旅の途中）
  "training.journey.statusTitle": { text: "旅の状況", label: "旅の欄の見出し（旅の途中）" },
  "training.journey.destination": { text: "目的地", label: "旅の欄の目的地の名前（旅の途中）" },
  "training.journey.period": { text: "期間", label: "旅の欄の期間の名前（旅の途中）" },
  "training.journey.hours": { text: "{時間}時間", label: "旅の欄の期間（選べる期間にない長さのとき）", note: "ふだんは下の「旅の期間」の文が出る", vars: "{時間}" },
  "training.journey.home": { text: "館", label: "旅の欄の航路の出発点の名前（旅の途中）", note: "航路の左端の小さな館の印の下" },
  "training.journey.until": { text: "帰還まで", label: "旅の欄の帰るまでの時間の名前" },
  "training.journey.canReturn": { text: "帰還可能！", label: "旅の欄の帰るまでの時間（帰れるとき）" },
  "training.journey.timeHms": { text: "{時間}時間 {分}分 {秒}秒", label: "旅の欄の帰るまでの時間（1時間以上）", vars: "{時間}・{分}・{秒}" },
  "training.journey.timeMs": { text: "{分}分 {秒}秒", label: "旅の欄の帰るまでの時間（1時間未満）", vars: "{分}・{秒}" },
  "training.journey.timeS": { text: "{秒}秒", label: "旅の欄の帰るまでの時間（1分未満）", vars: "{秒}" },
  "training.journey.timeReady": { text: "帰還可能", label: "旅の欄の帰るまでの時間（残りが0のとき）", note: "ふだんは「帰還可能！」が先に出るので、まず出ない" },

  // 旅の欄（予定報酬。旅の途中と旅に出す前の両方）
  "training.journey.rewardsTitle": { text: "予定報酬（目安）", label: "旅の欄の予定報酬の見出し", note: "旅の途中と旅に出す前の両方" },
  "training.journey.magic": { text: "魔力", label: "旅の欄の予定報酬の魔力の名前", note: "旅の長さと進化の段階で決まる" },
  "training.journey.magicQuantity": { text: "{魔力}", label: "旅の欄の予定報酬の魔力の量", vars: "{魔力}" },
  "training.journey.matCount": { text: "素材数", label: "旅の欄の予定報酬の素材数の名前" },
  "training.journey.matQuantity": { text: "{個数}個", label: "旅の欄の予定報酬の素材数", vars: "{個数}" },
  "training.journey.matBonus": { text: "+{個数} ボーナス", label: "旅の欄の予定報酬の素材数のボーナス", note: "属性が一致したとき", vars: "{個数}" },
  "training.journey.novelProb": { text: "作品入手確率", label: "旅の欄の予定報酬の作品入手確率の名前", note: "旅の途中は、確率が0でないときだけ" },
  "training.journey.novelProbNone": { text: "なし", label: "旅の欄の予定報酬の作品入手確率（0のとき）", note: "旅に出す前だけ" },
  "training.journey.skillBoost": { text: "★スキル込み", label: "旅の欄の予定報酬の作品入手確率の印（スキルで上がったとき）" },
  "training.journey.affinityActive": { text: "属性一致ボーナス適用中", label: "旅の欄の予定報酬（旅の途中・属性が一致したとき）", note: "前に ✦ の印" },
  "training.journey.returning": { text: "帰還中...", label: "帰還するボタン（帰還中）" },
  "training.journey.return": { text: "帰還する", label: "帰還するボタン" },
  "training.journey.away": { text: "旅に出ています…", label: "帰還するボタン（まだ帰れないとき）" },

  // 旅の欄（旅に出す前）
  "training.journey.setupTitle": { text: "旅に出す", label: "旅の欄の見出し（旅に出す前）" },
  "training.journey.slots": { text: "旅の途中: {今}/{上限} スロット", label: "旅の欄の旅のスロットの数", vars: "{今}・{上限}" },
  "training.journey.slotsFull": { text: "旅スロットが満杯です", label: "旅の欄（スロットがいっぱいのとき）の見出し" },
  "training.journey.slotsFullNote": { text: "クエストの解放目標を達成するとスロットが増えます", label: "旅の欄（スロットがいっぱいのとき）の説明", note: "下に、まだ解放していない旅立ち枠のノードの名前が並ぶ（スキルツリーで作ったもの）" },
  "training.journey.durationTitle": { text: "旅の期間", label: "旅の欄の期間を選ぶ見出し" },
  "training.journey.duration1h": { text: "1時間", label: "旅の期間（1時間）", note: "旅の途中の「期間」にも出る" },
  "training.journey.duration8h": { text: "8時間", label: "旅の期間（8時間）", note: "旅の途中の「期間」にも出る" },
  "training.journey.duration24h": { text: "24時間", label: "旅の期間（24時間）", note: "旅の途中の「期間」にも出る" },
  "training.journey.duration72h": { text: "72時間", label: "旅の期間（72時間）", note: "旅の途中の「期間」にも出る" },
  "training.journey.duration2w": { text: "2週間", label: "旅の期間（2週間）", note: "旅の途中の「期間」にも出る" },
  "training.journey.genreTitle": { text: "目的地ジャンル", label: "旅の欄の目的地を選ぶ見出し" },
  "training.journey.affinityBadge": { text: "属性一致ボーナス", label: "目的地を選ぶ見出しの横の印（属性が一致したとき）", note: "前に ✦ の印" },
  "training.journey.affinityMatch": { text: "属性一致: 素材+50% · 作品確率アップ", label: "旅の欄の予定報酬（旅に出す前・属性が一致したとき）", note: "前に ✦ の印" },
  "training.journey.affinityHint": { text: "属性と旅に出るジャンルが一致するとボーナスが発生します", label: "旅の欄の予定報酬（旅に出す前・属性が一致しないとき）", note: "目的地を選んだあと" },
  "training.journey.startError": { text: "旅立ちに失敗しました", label: "旅に出せなかったときの文", note: "サーバーが理由を返さなかったときだけ" },
  "training.journey.starting": { text: "旅立ち中...", label: "旅に出すボタン（旅立ち中）" },
  "training.journey.chooseGenre": { text: "ジャンルを選択してください", label: "旅に出すボタン（目的地を選んでいないとき）" },
  "training.journey.start": { text: "旅に出す", label: "旅に出すボタン" },

  // 手放す欄
  "training.release.title": { text: "精霊を手放す", label: "手放す欄の見出し" },
  "training.release.warning": { text: "手放すと精霊は失われ、魔力と素材を受け取ります。この操作は取り消せません。", label: "手放す欄の説明" },
  "training.release.rewardsTitle": { text: "手放すと受け取るもの", label: "手放す欄のもらえるものの見出し", note: "下に魔力・素材の数・素材の一覧" },
  "training.release.magicLabel": { text: "魔力", label: "手放す欄のもらえる魔力の名前" },
  "training.release.magicQuantity": { text: "+{魔力}", label: "手放す欄のもらえる魔力の量", vars: "{魔力}" },
  "training.release.materialsLabel": { text: "素材", label: "手放す欄のもらえる素材の合計の名前", note: "数は「旅の欄の予定報酬の素材数」と同じ文で出る" },
  "training.release.error": { text: "手放せませんでした", label: "手放せなかったときの文", note: "サーバーが理由を返さなかったときだけ" },
  "training.release.releasing": { text: "手放しています...", label: "手放すボタン（手放している間）" },
  "training.release.submit": { text: "この精霊を手放す", label: "手放すボタン" },

  // 進化できたときの板
  "training.evolveDone.title": { text: "進化成功!", label: "進化できたときの板の見出し" },
  "training.evolveDone.stage": { text: "進化段階 {段階}/{最大}", label: "進化できたときの板の段階", vars: "{段階}・{最大}" },

  // レベルが上がったときの板
  "training.levelUp.title": { text: "Level UP!", label: "レベルが上がったときの板の見出し" },
  "training.levelUp.level": { text: "Lv.{レベル}", label: "レベルが上がったときの板の新しいレベル", vars: "{レベル}" },

  // 育成できたとき（レベルは上がらない）
  "training.train.done": { text: "EXP を獲得しました", label: "育成できたときの小さな知らせ", note: "レベルが上がらなかったとき。画面の下に出る" },

  // 板の共通
  "training.common.tapToClose": { text: "タップして閉じる", label: "板を閉じる案内", note: "進化できたときの板・レベルが上がったときの板・絵を大きくした画面（育成の画面と図鑑）" },
} as const satisfies Record<string, UiTextDef>;
